import React from "react";
import moment from "moment";
import Search from "../../../../component/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import DynamicTable from "../../../../component/DynamicTable";
import WarningModal from "../../../../component/WarningModal";
import LongMenu from "../../../../component/LongMenu";
import PaginationFeature from "../../../../component/PaginationFeature/PaginationFeature";
import { useNavigate } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import { GrView } from "react-icons/gr";
import { FaCloudDownloadAlt} from "react-icons/fa";
import ProductPdfDirectSales from "../ManageProduct/ProductPdfDirectSales";

const ManageDiractSales = ({
  invoices,
  updateState,
  handleDeleteInvoice,
  isLoading,
  state,
  setPage,
  handleSearchInvoice,
}) => {
  const navigate = useNavigate();
  const columns = [
    "Sr.No.",
    "Supplier",
    "Style Name",
    "Stocks",
    "Delivery Date",
    "Total Amount",
    "Actions",
  ];

  const handleOptions = async (option, item) => {
    if (option.id == 1) {
      navigate("/inventory/view-direct-sales", { state: { data: item } });
    } else if (option.id == 2) {
      try {
        const blob = await pdf(<ProductPdfDirectSales data={item} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Purchase_Order.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
    else if (option.id === 3) {
      updateState({ id: item._id, isModalOpen: true });
    }
  };

  const menuOptions = [

    { id: 1, title: "View", icon: <GrView /> },
    { id: 2, title: "Download", icon: <FaCloudDownloadAlt /> },
    {
      id: 3,
      title: "Delete",
      icon: <DeleteIcon className="text-red-700" />,
      color: "red",
    },
  ];

  const transformedData = invoices.results?.map((item, index) => ({
    SrNo: (invoices.page - 1) * 20 + (index + 1),
    Supplier: item.purchaseOrderId?.suppiler || "N/A",
    StyleName: item.purchaseOrderId?.style_name || "N/A",
    totalStocks: item.quantity || "N/A",
    DeliveryDate: item.purchaseOrderId?.delivery_date
      ? moment(item.purchaseOrderId?.delivery_date).format("DD-MM-YYYY")
      : "N/A",
    TotalAmount:
      item?.totalAmount != null ? `₹${Math.round(parseFloat(item.totalAmount))}` : "N/A",
    actions: {
      value: (
        <LongMenu
          options={menuOptions}
          handleOptions={(prev) => handleOptions(prev, item)}
        />
      ),
    },
  }));



  return (
    <div>
      {/* Header */}
      <div className="flex md:flex-row flex-col md:justify-between justify-start gap-3 mb-6 md:px-2 px-4 md:py-0 py-1">
        <h1 className="md:text-[28px] text-[20px] font-bold text-gray-800">
          Manage Direct Sales
        </h1>
        <Search
          handleSeachButton={() => handleSearchInvoice(1)}
          onChange={(e) => updateState({ query: e.target.value })}
          value={state.query}
          placeholder="Style Name"
        />
      </div>

      <div className="bg-white shadow rounded-md md:p-6 p-2 min-h-screen">
        <DynamicTable
          data={transformedData}
          columns={columns}
          defaultRowSelected={[]}
          checkbox={false}
        />
        <PaginationFeature totalPage={invoices.totalPages} setPage={setPage} />
      </div>

      <WarningModal
        isOpen={state.isModalOpen}
        onClose={() => updateState({ isModalOpen: false })}
        modalTitle="Are you sure you want to delete this item?"
        onConfirm={handleDeleteInvoice}
        onCancel={() => updateState({ isModalOpen: false })}
        confirmText={isLoading ? "Deleting..." : "Delete"}
        cancelText="Cancel"
        isLoading={isLoading}
      />
    </div>
  );
};

export default ManageDiractSales;
